import React from 'react'

const CaseViolationItem = ({ citation }) => {
  const { citationId, issuedAt, violation, balanceDue } = citation

  return (
    <div className="bg-white rounded-lg p-2.5 text-gray-600 mb-2">
      <div className="flex justify-between pb-3">
        <span>{citationId}</span>
        <span>{issuedAt.split('-').join('/')}</span>
      </div>
      <div className="flex justify-between">
        <span>{violation}</span>
        <span className="font-bold">{`$${balanceDue}`}</span>
      </div>
    </div>
  )
}

export default CaseViolationItem
